module.exports = __webpack_public_path__ + "static/media/staticDefaultNotification.60312dc6.svg";